<app-dashboard>
    <p>settings works!</p>
</app-dashboard>
